import CashierReferralProgram from "src/modules/cashier-referral/CashierReferralProgram";

export default CashierReferralProgram;
